// extracted by mini-css-extract-plugin
export default {"close":"AuthModal_close__90XRu"};